import React, { Fragment, Component, memo } from "react";
import Airtable from "airtable";
import pick from "lodash.pick";

import Onboarding from "./components/Onboarding";
import ApiForm from "./components/ApiForm";
import ExpensesTable from "./components/ExpensesTable";
import ExpensesChart from "./components/ExpensesChart";

class App extends Component {
  state = {
    expenses: {},
    apiKey: null,
    baseId: null,
    fetching: false,
    enteringKeys: false,
    error: null,
  };

  componentDidUpdate = (prevProps, prevState) => {
    const savedState = pick(this.state, ["expenses", "apiKey", "baseId"]);
    localStorage.setItem("expenses", JSON.stringify(savedState));
  };

  componentDidMount = () => {
    const cache = localStorage.getItem("expenses");
    if (cache) {
      try {
        this.setState(JSON.parse(cache));
      } catch (e) {
        console.error("Error deserializing localStorage cache.");
      }
    }
  };

  fetchAirtable = () => {
    const { apiKey, baseId } = this.state;
    Airtable.configure({
      endpointUrl: "https://api.airtable.com",
      apiKey,
    });
    const base = Airtable.base(baseId);

    const expenses = {};
    this.setState({ fetching: true });

    base("Expenses")
      .select({
        maxRecords: 9999999,
        view: "Grid view",
      })
      .eachPage(
        (records, fetchNextPage) => {
          records.forEach(({ id, fields }) => (expenses[id] = fields));
          fetchNextPage();
        },
        error => {
          if (error) {
            this.setState({ fetching: false, error });
          } else {
            this.setState({ expenses, fetching: false });
          }
        }
      );
  };

  render() {
    const {
      expenses,
      fetching,
      apiKey,
      baseId,
      enteringKeys,
      error,
    } = this.state;

    const showKeyForm = enteringKeys || (!apiKey || !baseId);
    // appg046Kuk2GqSVWb
    // key64EALwRgh5bJv4
    return (
      <div className="container mx-auto my-4 px-2">
        {showKeyForm && (
          <Fragment>
            <Onboarding />
            <ApiForm
              onChange={({ apiKey, baseId }) =>
                this.setState({ apiKey, baseId, enteringKeys: true })
              }
              value={{ apiKey, baseId }}
              onSubmit={() => {
                this.setState({ enteringKeys: false });
                this.fetchAirtable();
              }}
            />
          </Fragment>
        )}
        {showKeyForm || (
          <Fragment>
            <ExpensesChart expenses={expenses} />
            <br />
            <ExpensesTable expenses={expenses} />
            <br />
            <button
              onClick={this.fetchAirtable}
              className="bg-green-500 hover:bg-green-600 text-green-100 font-bold py-2 px-4 rounded"
              disabled={fetching}
            >
              {fetching ? "Refreshing..." : "Refresh data"}
            </button>
            <button
              onClick={() => this.setState({ enteringKeys: true })}
              className="hover:bg-grey-100 ml-2 py-2 px-4 border rounded"
            >
              Edit Airtable keys
            </button>
            {error && (
              <div role="alert">
                <div className="bg-red-500 text-white font-bold rounded-t px-4 py-2">
                  Error: {error.error}
                </div>
                <div className="border border-t-0 border-red-400 rounded-b bg-red-100 px-4 py-3 text-red-600">
                  <p />
                  {error.message}. Try re-entering your Airtable keys?
                </div>
              </div>
            )}
          </Fragment>
        )}
      </div>
    );
  }
}

export default App;
